import { render, staticRenderFns } from "./takeGoods.vue?vue&type=template&id=2b63f0f2&scoped=true&"
import script from "./takeGoods.vue?vue&type=script&lang=js&"
export * from "./takeGoods.vue?vue&type=script&lang=js&"
import style0 from "./takeGoods.vue?vue&type=style&index=0&id=2b63f0f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63f0f2",
  null
  
)

export default component.exports